// client/src/pages/Weddings/steps/DessertsStep/components/QuantityStepper.jsx
import React from "react";
import { Box, Stack, IconButton, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export default function QuantityStepper({
  value,
  onChange,
  onInc,
  onDec,
  minPieces,
  stepPieces,
}) {
  const displayValue = value === 0 ? minPieces : value;

  return (
    <Box sx={{ mt: 1.5 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1.5}>
        <IconButton
          size="small"
          onClick={onDec}
          aria-label="decrease quantity"
          disabled={value === 0}
          sx={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            border: "1px solid",
            borderColor: "divider",
          }}>
          <RemoveIcon fontSize="small" />
        </IconButton>

        <Box sx={{ flex: "0 0 160px" }}>
          <TextField
            fullWidth
            type="number"
            size="small"
            value={displayValue}
            onChange={(e) => onChange(e.target.value)}
            inputProps={{ min: 0, step: stepPieces }}
            sx={{
              "& .MuiInputBase-input": { textAlign: "center", fontWeight: 700 },
            }}
          />
        </Box>

        <IconButton
          size="small"
          onClick={onInc}
          aria-label="increase quantity"
          sx={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            border: "1px solid",
            borderColor: "divider",
          }}>
          <AddIcon fontSize="small" />
        </IconButton>
      </Stack>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", textAlign: "center", mt: 0.75 }}>
        Increments of +{stepPieces}
      </Typography>
    </Box>
  );
}
